import { createContext, useContext } from 'react'

import { AnyRouter, RouteApi } from '@tanstack/react-router'
import { DocTemplateEdit, TemplateFormType } from '~bank-document-templates/types'

export type TemplateManageFormApi = TemplateFormType

type TemplateManageContextValue = {
  formApi: TemplateManageFormApi
  routeApi: RouteApi<'/_app/document-templates/$id/edit', AnyRouter>
  data: DocTemplateEdit
}

export const TemplateManageContext = createContext<TemplateManageContextValue | undefined>(undefined)

export const useTemplateManageContext = () => {
  const context = useContext(TemplateManageContext)
  if (!context) {
    throw new Error('useTemplateManageContext must be used within a TemplateManageContext.Provider')
  }
  return context
}
